import * as React from 'react';
import CheckOutlined from 'dw-neit-icons/CheckOutlined';
import CopyOutlined from 'dw-neit-icons/CopyOutlined';
import LoadingOutlined from 'dw-neit-icons/LoadingOutlined';
import classNames from 'classnames';
import TransButton from '../../_util/transButton';
import Tooltip from '../../tooltip';
import { getNode, toList } from './util';
const CopyBtn = (props) => {
    const { prefixCls, copied, locale, iconOnly, tooltips, icon, loading: btnLoading, tabIndex, onCopy, } = props;
    const tooltipNodes = toList(tooltips);
    const iconNodes = toList(icon);
    const { copied: copiedText, copy: copyText } = locale !== null && locale !== void 0 ? locale : {};
    const copyTitle = copied
        ? getNode(tooltipNodes[1], copiedText)
        : getNode(tooltipNodes[0], copyText);
    const systemStr = copied ? copiedText : copyText;
    const ariaLabel = typeof copyTitle === 'string' ? copyTitle : systemStr;
    return (React.createElement(Tooltip, { key: "copy", title: copyTitle },
        React.createElement(TransButton, { className: classNames(`${prefixCls}-copy`, {
                [`${prefixCls}-copy-success`]: copied,
                [`${prefixCls}-copy-icon-only`]: iconOnly,
            }), onClick: onCopy, "aria-label": ariaLabel, tabIndex: tabIndex }, copied
            ? getNode(iconNodes[1], React.createElement(CheckOutlined, null), true)
            : getNode(iconNodes[0], btnLoading ? React.createElement(LoadingOutlined, null) : React.createElement(CopyOutlined, null), true))));
};
export default CopyBtn;
